import http from '../common/http-auth'
import httpFileUpload from '../common/http-auth-fileupload'
import type {exportJobParam} from "../components/types/types";

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
export const getJobListById = async (data: any) => {
    const response = http.post(`/amp/job/getjobslist`, data)
    return response ;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const getCSVColumnMapping = async () => {
    const response = http.get(`/amp/jobrequest/getcsvcolumnmapping`)
    return response ;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
export const addJobRequestData = async (data: any) => {
    const response = httpFileUpload.post(`/amp/jobrequest/add`, data)
    return response ;
}


// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const getColumnListByJId = async (jobid?: number) => {
    const response = http.get(`/amp/job/gettablecolumns?jobid=${jobid !== undefined ? jobid : ''}`)
    return response ;
}
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const ExportJobData = async (data: exportJobParam) => {
    const response = http.post(`/amp/export/report`, data, {
        responseType: 'blob', 
      })
    return response;
}
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const ExportStandardJobData = async (data: exportJobParam) => {
    const response = http.post(`/amp/export/standardreport`, data, {
        responseType: 'blob', 
      })
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
export const convertCountToOrder = async (data: any) => {
    const response = http.post(`/amp/jobrequest/convertcounttoorder`, data)
    return response ;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const DownloadSourceCSV = async (jobid?: number) => {
    const response = http.get(`/amp/jobrequest/downloadsourcecsv?jobid=${jobid !== undefined ? jobid : ''}`)
    return response ;
}